import { RangePresetsDefault } from "@src/constant/default-range-picker-presets";
import { COHORT_DATE } from "@src/pages/ab-test-explore/contanst";
import { FilterFormFieldsEnum } from "@src/pages/ab-test-explore/enum";
import { trackEventPayload } from "@src/util/track-event-payload";
import { DatePicker, DatePickerProps, Form } from "antd";
import { FormInstance } from "antd/lib/form";
import dayjs from "dayjs";
import React from "react";
import { useTracking } from "react-tracking";
import { Dayjs } from "dayjs";

const { RangePicker } = DatePicker;
const getDateRangeWithDayDiff = (dateRange: any[], dayDiff: number) => {
  const [start, end] = dateRange;
  return [dayjs(start), dayjs(end).add(dayDiff, "day")];
};
export const TimeRangeFilter: React.FC<{ form: FormInstance<any> }> = ({ form }) => {
  const { trackEvent } = useTracking();
  const [isDisabled, setIsDisabled] = React.useState(false);

  const cohortDateWatch = Form.useWatch(FilterFormFieldsEnum.COHORT_DATE, form);
  const maxDayDiffWatch = Form.useWatch(FilterFormFieldsEnum.MAX_DAY_DIFF, form);
  const extraFilterConfirmedWatch = Form.useWatch(FilterFormFieldsEnum.EXTRA_FILTER_VALUES_CONFIRMED, form);

  React.useEffect(() => {
    if (!extraFilterConfirmedWatch) return;
    try {
      const extraFilterConfirmedParsed = JSON.parse(extraFilterConfirmedWatch);
      const extraInstallDate = extraFilterConfirmedParsed?.[FilterFormFieldsEnum.EXTRA_INSTALL_DATE];
      const extraOnboardingDate = extraFilterConfirmedParsed?.[FilterFormFieldsEnum.EXTRA_ONBOARDING_DATE];

      let timeRangeBaseOnRule: Dayjs[] | undefined = undefined;
      if (!!extraInstallDate && cohortDateWatch === COHORT_DATE.INSTALL_DATE) {
        timeRangeBaseOnRule = getDateRangeWithDayDiff(extraInstallDate, maxDayDiffWatch);
      }
      if (!!extraOnboardingDate && cohortDateWatch === COHORT_DATE.ONBOARDING_DATE) {
        timeRangeBaseOnRule = getDateRangeWithDayDiff(extraOnboardingDate, maxDayDiffWatch);
      }

      if (timeRangeBaseOnRule) {
        form.setFieldValue(FilterFormFieldsEnum.TIME_RANGE, timeRangeBaseOnRule);
        setIsDisabled(true);
        return;
      }
      setIsDisabled(false);
    } catch (error) {
      console.log(error);
    }
  }, [cohortDateWatch, maxDayDiffWatch, form, extraFilterConfirmedWatch]);

  const disabledDate: DatePickerProps["disabledDate"] = (current, { from }) => {
    if (current && dayjs(current).isAfter(dayjs())) {
      return true;
    }
    return false;
  };

  return (
    <Form.Item
      label="Time Range"
      name={FilterFormFieldsEnum.TIME_RANGE}
      required
      rules={[
        {
          message: "Please select time range",
          required: true,
        },
      ]}
    >
      <RangePicker
        disabledDate={disabledDate}
        disabled={isDisabled}
        presets={RangePresetsDefault}
        style={{
          backgroundColor: "white",
        }}
        onChange={(_, dateStrings) => {
          trackEvent(trackEventPayload.baseMetricFieldUpdated("time_range", dateStrings));
        }}
      />
    </Form.Item>
  );
};
